import { FormStatusEnum } from '../data-access/types/stats';

export const chartsColors = {
  green: '#87BC25',
  grey: '#B8B8B6',
  red: '#DE6E6A',
  yellow: '#F3C96B',
};

export const statusChartcolorsMap = {
  [FormStatusEnum.FINISHED]: chartsColors.green,
  [FormStatusEnum.REJECTED]: chartsColors.red,
  [FormStatusEnum.UNDEFINED]: chartsColors.yellow,
  [FormStatusEnum.ERROR]: chartsColors.grey,
  empty: '#f8f9fa',
};
